import { render, staticRenderFns } from "./TooltipMount.vue?vue&type=template&id=7454e5b4&scoped=true"
import script from "./TooltipMount.vue?vue&type=script&lang=js"
export * from "./TooltipMount.vue?vue&type=script&lang=js"
import style0 from "./TooltipMount.vue?vue&type=style&index=0&id=7454e5b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7454e5b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
